import { render } from "./BrokersAdsPackagesWidget.vue?vue&type=template&id=6ef6b5c2&scoped=true&ts=true"
import script from "./BrokersAdsPackagesWidget.vue?vue&type=script&lang=ts"
export * from "./BrokersAdsPackagesWidget.vue?vue&type=script&lang=ts"

import "./BrokersAdsPackagesWidget.vue?vue&type=style&index=0&id=6ef6b5c2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef6b5c2"]])

export default __exports__